const pub = {
  "pub.whatsapp_default_msg": "Hello, I am interested in a treatment at Esteva Clinic.",
  "pub.error_title": "An error has occurred",
  "pub.error_message": "Please reload the page. If the problem persists, please disable browser translation/extensions.",
  "pub.error_reload": "Reload page",
  "pub.pill_1": "Dental implants Albania",
  "pub.pill_2": "Hair transplant FUE",
  "pub.pill_3": "Rhinoplasty nose correction",
  "pub.pill_4": "Breast augmentation",
  "pub.pill_5": "Facelift",
  "pub.pill_6": "Liposuction",
  "pub.pill_7": "Veneers zirconia crowns",
  "pub.pill_8": "Botox hyaluron",
  "pub.pill_9": "Tummy tuck",
  "pub.pill_10": "Medical Tourism Albania",
  "pub.pill_11": "70% cheaper than Switzerland",
  "pub.pill_12": "Premium clinic Tirana",
  "pub.country_albania": "Albania",
  "pub.opening_hours_default": "Mon–Fri: 08:00–20:00 | Sat: 09:00–16:00 | Sun: Closed",
  "pub.fkw_1": "Dental implants Albania",
  "pub.fkw_2": "Zirconia crowns",
  "pub.fkw_3": "Veneers",
  "pub.fkw_4": "Teeth whitening",
  "pub.fkw_5": "Hair transplant FUE",
  "pub.fkw_6": "Breast augmentation Albania",
  "pub.fkw_7": "Rhinoplasty nose correction",
  "pub.fkw_8": "Botox Tirana",
  "pub.fkw_9": "Liposuction Albania",
  "pub.fkw_10": "Facelift",
  "pub.fkw_11": "Tummy tuck",
  "pub.fkw_12": "Breast lift",
  "pub.fkw_13": "Breast reduction",
  "pub.fkw_14": "Eyelid surgery",
  "pub.fkw_15": "BBL Albania",
  "pub.fkw_16": "Intimate surgery",
  "pub.fkw_17": "Plastic surgery Albania",
  "pub.fkw_18": "Aesthetic surgery Tirana",
  "pub.fkw_19": "Medical tourism Albania",
  "pub.fkw_20": "Dental tourism",
  "pub.fkw_21": "70% cheaper than Switzerland",
  "pub.fkw_22": "70% cheaper than Germany",
  "pub.fkw_23": "Dentist abroad",
  "pub.fkw_24": "Premium clinic Tirana",
  "pub.fkw_25": "Free initial consultation",
};

export default pub;
